import React from "react";
import { Container, Title, Subtitle } from "./Styled";

export default function NotFound() {
  return (
    <Container>
      <Title>Page not found</Title>
      <Subtitle>The page you are looking for doesn't exist</Subtitle>
    </Container>
  );
}
